import React from 'react'
import './Search.css'
import { AiOutlineSearch } from "react-icons/ai";

const Searchs = ({searchval}) => {
  const handleChange = (e) =>{
    searchval(e.target.value)
  }
  return (
    <div className='dtn-midle-container'>
      <input onChange={handleChange} className='dt-search-field' type="text" placeholder='Search'/>
      <AiOutlineSearch id='dt-icons-search'/>
    </div>
  )
}

export default Searchs